import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../LanguageContext";
import "./index.css";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const videos = Array.from({ length: 20 }, (_, i) => ({
  id: `video-${i + 1}`,
  titleKey: `flm.forward.video${i + 1}#title`,
  descriptionKey: `flm.forward.video${i + 1}#description`,
  videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
  thumbnail:
    i % 2 === 0
      ? "/assets/images/full-life-music/compact-black.png"
      : "/assets/images/full-life-music/compact-white.png",
}));

export function VideoPage({ match }) {
  const { t } = useLanguage();
  const videoId = match.params.videoId;
  const video = videos.find((v) => v.id === videoId);

  const videoRef = useRef(null);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const startTime = parseFloat(params.get("t") || "0");

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.currentTime = startTime;
    }
  }, [startTime]);

  if (!video) {
    return (
      <div className="video-page">
        <div className="video-page-header">
          <Link
            to={`${process.env.PUBLIC_URL}/flm/forward`}
            className="back-button"
          >
            ← {t("flm.forward#backToList")}
          </Link>
          <h1>Video not found</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="video-page">
      <div className="video-page-header">
        <Link
          to={`${process.env.PUBLIC_URL}/flm/forward`}
          className="back-button"
        >
          ← {t("flm.forward#backToList")}
        </Link>
        <h1>{t(video.titleKey)}</h1>
      </div>
      <div className="video-page-content">
        <div className="video-player-container">
          <video
            ref={videoRef}
            src={video.videoUrl}
            controls
            autoPlay
            className="video-player-main"
          />
        </div>
        <div className="video-info">
          <p className="video-description">{t(video.descriptionKey)}</p>
        </div>
      </div>
    </div>
  );
}
